import type { SbBlokData } from "@storyblok/react";
import axios from "axios";
import { useState } from "react";
import type { StoryblokRichtext } from "storyblok-rich-text-react-renderer";

import useInput from "@/lib/hooks/useInput";

import UI from "./UI";

export interface NewsletterBlok extends SbBlokData {
  title?: string;
  text?: StoryblokRichtext;
  buttonText?: string;
  successMessage?: string;
}

export interface NewsletterProps {
  blok: NewsletterBlok;
}

const Newsletter = ({ blok }: NewsletterProps) => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const email = useInput("email");
  const apiUrl = process.env.NEXT_PUBLIC_CENTRA_CHECKOUT_API;

  const handleSubmit = async (e?: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault();

    try {
      const res = await axios.post(
        `${apiUrl}/newsletter-subscription/${email.value}`,
        {}
      );

      if (res.status === 201) {
        setSuccess(true);
        email.clear();
        return;
      }
      setError(true);
    } catch {
      setError(true);
    }
  };

  return (
    <UI
      blok={blok}
      email={email}
      handleSubmit={handleSubmit}
      success={success}
      error={error}
    />
  );
};

export default Newsletter;
